/**
 * Webtarot app icon shown on auth / legal pages.
 */
export default function WTMonogram() {
  return (
    <div className="login-monogram">
      <img
        src="/webtarot-app-icon.png"
        alt="Webtarot"
        width={64}
        height={64}
        draggable={false}
      />
    </div>
  );
}
